import { createSlice } from '@reduxjs/toolkit';
const initialState = "/mypage/jobinfo_list";
const jobinfoDetailPrevSlice = createSlice({
    name: 'userJobinfoDetailPrev',
    initialState,
    reducers: {
        changePrevUrlAction(state, action) {
            return state = action.payload;
        },
    },
});
//Actions
export const { changePrevUrlAction, } = jobinfoDetailPrevSlice.actions;
export default jobinfoDetailPrevSlice;
